// Small display helpers for laptop RAM / Storage specs.
// V2.1 — a value of 0 means "explicitly configured as No RAM / No SSD"
// (a valid purchase state for barebones units). A null/undefined value
// means "not recorded" and is rendered with the neutral "—" placeholder.

export function formatRam(ram_gb) {
  if (ram_gb === 0) return "No RAM";
  if (ram_gb == null || ram_gb === "") return "—";
  return `${ram_gb} GB`;
}

export function formatStorage(storage_gb, storage_type) {
  if (storage_gb === 0) return "No SSD";
  if (storage_gb == null || storage_gb === "") return "—";
  const type = storage_type ? ` ${storage_type}` : "";
  return `${storage_gb} GB${type}`;
}
